export default __webpack_public_path__ + "static/media/caveat-v9-latin_cyrillic-700.47ec8b28.woff";